let selectMap = {
  getName (key, value) {
    let obj = selectMap[key]
    if (obj && obj[value]) {
      return obj[value].name
    }
    return ''
  },
  // 编码类型
  barcode: {
    'Y': {value: 'Y', name: '自编码'},
    'N': {value: 'N', name: '称重码'}
  },
  // 单据状态
   djStatusList: {
    '1': {value: '1',  name: '草稿'},
    '2': {value: '2',  name: '已提交'},
    '3': {value: '3',  name: '已完成'},
    '4': {value: '4',  name: '已作废'},
    '7,8,9,10,15': {value: '7,8,9,10,15',  name: '审批中'},
    '6': {value: '6',  name: '审批驳回'},
    '12': {value: '12',  name: '处理中'}
  },
  // 全局 (单品状态)
  dpStatusList: {
    '5': {value: '5', name: '建档成功'},
    '11,13,17,14,12': {value: '11,13,17,14,12', name: '审批中'},
    // '1': {value: '1', name: '待审核'},
    // '11': {value: '11', name: '待审批'},
    '16': {value: '16', name: '采购驳回'},
    '15': {value: '15', name: '处理中'},
    '9': {value: '9', name: '发送失败'},
    '8': {value: '8', name: '草稿'},
    // '2': {value: '2', name: '已审核'},
    '7': {value: '7', name: '建档取消'},
    '6': {value: '6', name: '建档失败'},
    // '4': {value: '4', name: '待处理'},
    // '3': {value: '3', name: '审核驳回'},
    '18': {value: '18', name: '已提交'}
  }
}
export default selectMap



// WEBPACK FOOTER //
// ./src/common/select-map.js